export type DeviceDetailTab = "overview" | "placement" | "history";

export const DEVICE_DETAIL_TAB_LABELS: Record<DeviceDetailTab, string> = {
  overview: "Overview",
  placement: "Placement",
  history: "History",
};

export const NONE_VALUE = "";

export function ensureOption(
  options: Array<{ value: string; label: string }>,
  value: string | null | undefined,
): Array<{ value: string; label: string }> {
  const trimmed = value?.trim();
  if (!trimmed) return options;
  if (options.some((o) => o.value === trimmed)) return options;
  return [{ value: trimmed, label: trimmed }, ...options];
}

/** Placement-only PATCH body. Omits profile/branding so server merge keeps legacy IDs. */
export function buildPlacementPatch(input: {
  location: string;
  organization: string;
  assignedTo: string;
  notes: string;
}) {
  return {
    location: input.location.trim() || null,
    organization: input.organization.trim() || null,
    assignedTo: input.assignedTo.trim() || null,
    notes: input.notes.trim() || null,
  };
}

export function hasLegacyMdmAssignments(device: {
  deviceProfileId?: string | null;
  deviceBrandingId?: string | null;
}): boolean {
  return Boolean(device.deviceProfileId?.trim() || device.deviceBrandingId?.trim());
}
